import { React } from 'react';
import { PropTypes } from 'prop-types';
// import { FormattedMessage } from 'react-intl';
import { Button } from 'carbon-components-react';
import { Close } from '@carbon/icons-react';
import './NoteDrawer.scss';

export default function NoteDrawer({ drawerOpen, setDrawerOpen }) {
  const closeDrawer = () => setDrawerOpen(false);

  return (
    <>
      <div
        className={`widget-drawer-backdrop ${
          drawerOpen ? 'opened' : 'closed'
        } widget-drawer-transition`}
        onClick={closeDrawer}></div>
      <div
        className={`widget-drawer ${
          drawerOpen ? 'opened' : 'closed'
        } widget-drawer-transition`}>
        <div className="widget-drawer-inner-container">
          <div className="widget-drawer-close-container">
            <Button
              className="widget-drawer-close-btn"
              kind="ghost"
              renderIcon={Close}
              onClick={closeDrawer}>
              Close{' '}
            </Button>
          </div>
          <div className="widget-drawer-notes-container">
            <p className="widget-drawer-notes-headline">
              Total Servers in the Environment
            </p>
            <ul className="widget-drawer-notes-list">
              <li className="widget-drawer-notes-item">
                A physical server is typically a physical computer that is
                comprised of processing units, memory, and input/output
                capabilities and that executes requested procedures, commands,
                or applications for one or more users or client devices. Where
                racks, blade enclosures, or other similar equipment is being
                employed, each separable physical device (for example, a blade
                or a rack-mounted device) that has the required components is
                considered itself a separate server. A virtual server is a
                virtual computer created by logically partitioning physical
                resources into sub-computers that execute requested procedures,
                commands, or applications for one or more users or client
                devices.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

NoteDrawer.propTypes = {
  drawerOpen: PropTypes.bool,
  setDrawerOpen: PropTypes.func,
};
